/*
 * @Description: 研究报告管理
 * @Author: yy
 * @LastEditors  : yy
 * @Date: 2019-04-16 15:26:25
 * @LastEditTime : 2020-01-08 14:59:31
 */
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import classNames from 'classnames'
// @ts-ignore
import s from './style.css';
import { addResearchReport, deleteResearchReport, updateResearchReport, setStickResearchReport, getResearchReportByUrl, getResearchReportList, checkReport, addResearchReportPicture } from '../../controller';
import TimeInput from '../../components/TimeInput/TimeInput';
import AdminBackNav from '../adminBackNav/adminBackNav';

const filterUrl = (url) => {
  // 如果是pdf文件
  if (/\.pdf$/g.test(url)) {
    const host = /^.+?\/\/.+?\//.exec(url)[0]
    return `${host}static/pdf/web/index.html?file=${encodeURI(url)}`
  }
  return url
}

class ReportFrom extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showText: true,
      date: '',
      articleUrl: '',
      article_url: '',
      digest: '',
      headline: '',
      imgId: '',
      id: null,
      picture_url: '',
      release_date: '',
      stick: false,
      articleType: 'wx',
      showImg: false,
      showDate: false,
      deleteUrl: '',
      imgFile: null,
      isDisable: false,

      isEdit: false,
      list: [],
      show: false,
      picFiles: null,
      pdfFiles: null
    }

    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.saveReport = this.saveReport.bind(this)
    this.changeHandle = this.changeHandle.bind(this)
    this.changeTopReport = this.changeTopReport.bind(this)
    this.deleteReport = this.deleteReport.bind(this)
    this.renderListItem = this.renderListItem.bind(this)
    this.checkReport = this.checkReport.bind(this)
    this.changeFiles = this.changeFiles.bind(this)
    this.upLoadFiles = this.upLoadFiles.bind(this)
    this.changeReport = this.changeReport.bind(this)
    this.changeValueTitle = this.changeValueTitle.bind(this)
    this.changeDigest = this.changeDigest.bind(this)
    this.upLoadFilesAction = this.upLoadFilesAction.bind(this)
  }

  componentDidMount () {
    this.getResearchReportList()
  }

  /**
   * 获取研究报告列表
   */
  getResearchReportList () {
    getResearchReportList({
      pageNum: 3,
      key: 'b'
    })
      .then(res => {
        if (res) {
          this.setState({
            list: res.stickReportList
          })
        }
      })
  }


  /**
   * 打开弹出窗口
   * @param {Boolean} isNew 
   */
  open (isNew = false) {
    let state = {
      show: true,
      isEdit: false
    }
    if (isNew) {
      state = Object.assign(state, {
        headline: '',
        // releaseDate: '',
        date: '',
        stick: 'false',
        articleType: 'wx',
        articleUrl: '',
        digest: '',
        picFiles: null,
        pdfFiles: null,
        isEdit: true,
        picture_url: '',
        id: null,
        imgId: null
      })
    }
    this.setState(state)
  }

  /**
   * 关闭弹出窗口
   */
  close () {
    this.setState({
      show: false
    })
  }

  /**
   * 新增报告
   */
  addReport (params, fn) {
    addResearchReport(params)
      .then(res => {
        if (res.id) {
          this.setState({
            imgId: res.id
          });
          this.getResearchReportList()
          typeof fn === 'function' && fn()
          alert("添加成功！");
        } else {
          alert("添加失败！");
        }
      })
  }

  /**
   * 修改报告
   */
  updateReport (params, fn) {
    updateResearchReport(params)
      .then(res => {
        if (res === true) {
          this.getResearchReportList()
          typeof fn === 'function' && fn()
          alert("修改成功！")
        } else {
          alert("修改失败！");
        }
      })
  }

  /**
   * 保存报告
   */
  saveReport (fn) {
    const { headline, digest, date, stick, articleUrl, articleType, id, isEdit } = this.state

    const params = {
      headline: headline,
      digest: digest,
      releaseDate: date,
      stick: stick,
      articleUrl: articleUrl,
      articleType: articleType
    }

    if (params.headline == '' || params.digest == '' || params.releaseDate == '' || params.articleUrl == '') {
      return alert('请填写必要信息')
    }

    if (!confirm('确定保存')) { return false }
    if (isEdit) {
      this.addReport(params, fn)
    } else {
      params['id'] = id
      this.updateReport(params, fn)
    }
  }


  /**
   * 删除报告
   */
  deleteReport (url) {
    const bool = confirm('确定删除该数据')
    if (!bool) {
      return false
    }
    
    const params = {
      articleUrl: url
    }

    deleteResearchReport(params)
      .then((res) => {
        this.getResearchReportList()

        if (res === true) {
          alert("删除成功！");
        } else {
          alert("删除失败！")
        }
      })
  }

  changeHandle (key, value) {
    this.setState({
      [key]: value
    })
  }

  /**
   * 置顶/却笑置顶
   * @param {String} url 
   * @param {Boolean} stick 
   */
  changeTopReport (url, stick) {
    const bool = confirm(`确定${ stick ? '取消' : ''}置顶该数据`)

    if (!bool) {
      return false
    }

    const params = {
      articleUrl: url,
      key: stick ? 'cancel' : 'set'
    }

    setStickResearchReport(params)
      .then(res => {
        this.setState({
          articleUrl: '',
        })
        this.getResearchReportList()

        if (res === true) {
          alert("修改成功！");
        } else {
          alert("修改失败！")
        }
      })
  }

  /**
   * 通过url获取报告信息
   * @param {String} url 
   */
  changeReport (url) {
    const params = {
      articlUrl: url
    }

    this.open()
    
    getResearchReportByUrl(params)
      .then(res => {
        if (res) {
          const { article_url, digest, headline, id, picture_url, release_date, stick } = res
          
          let type = 'wx'
          if (/\.pdf$/g.test(article_url)) {
            type = 'pdf'
          }

          this.setState({
            id: id,
            articleType: type,
            imgId: id,
            articleUrl: article_url,
            digest: digest,
            headline: headline,
            picture_url: picture_url,
            date: release_date,
            stick: stick
          })
        } else {
          this.setState({
            isEdit: true
          })
          alert("获取信息失败！")
        }
      })
  }


  changeDigest (e) {
    //摘要信息获取
    if (e.target.value.length <= 72) {
      this.setState({
        digest: e.target.value
      })
    } else {
      alert("摘要文字长度不能大于72个字！")
      e.target.value = this.state.digest
    }
  }


  changeValueTitle (e) {
    //标题信息获取
    if (e.target.value.length <= 32) {
      this.setState({
        headline: e.target.value
      })
    } else {
      e.target.value = this.state.headline
    }
  }

  /**
   * 通过审核
   * @param {*} id 
   */
  checkReport (id) {
    checkReport({id: id})
      .then(res => {
        this.getResearchReportList()
        if(res.info === 'success') {
          alert('审核通过')
        } else {
          alert('审核失败')
        }
      })
  }

  renderListItem (item) {
    return (
      <div className={classNames(s.reportListItem, {
        [s.stick]: item.stick
      })} key={item.id}>
        <div className={s.reportImgWrapper}>
          <img className={s.reportImg} src={item.picture_url} alt={item.headline} />
        </div>
        <div>
          <h3 className={s.reportHeadline}>
            <a href={filterUrl(item.article_url)} target="_blank">{item.headline}</a>
            {/* <a href={item.article_url} target="_blank">{item.headline}</a> */}
          </h3>
          <p>{item.digest}</p>
          <p>{item.release_date}</p>
        </div>

        <div className={s.btnGroup}>
          <button className={classNames(s.btn)} onClick={() => this.changeReport(item.article_url)}>编辑报告</button>
          <button className={classNames(s.btn, s.danger)} onClick={() => this.changeTopReport(item.article_url, item.stick)}>{item.stick ? '取消置顶' : '置顶'}</button>
          <button className={classNames(s.btn, s.danger)} onClick={() => this.deleteReport(item.article_url)}>删除</button>
          {item.check ? null : <button className={classNames(s.btn, s.danger)} onClick={() => this.checkReport(item.id)}>通过审核</button>}
        </div>
      </div>
    )
  }

  renderList () {
    const list = this.state.list
    return (
      <div>
        {list.map(this.renderListItem)}
      </div>
    )
  }

 

  /**
   * 监听文件改变
   * @param {*} e 
   * @param {String} name 
   */
  changeFiles (e, name) {
    const files = e.target.files
    const size = 10
    if (files[0].size > 1024 * 1024 * size) {
      return alert(`文件大小不能超过${size}兆`)
    }
    this.setState({
      [name]: e.target.files
    })
  }


  /**
   * 上传文件
   * @param {String} name 
   */
  upLoadFiles (name) {
    const files = this.state[name]
    if (!files) {
      return alert('请选择文件')
    }

    if (!this.state.imgId) {
      this.saveReport(() => {
        this.upLoadFilesAction(name, files)
        setTimeout(() => {
          this.getResearchReportList()
        }, 300)
      })
    } else {
      this.upLoadFilesAction(name, files)
    }
  }

  /**
   * 上传文件
   * @param {String} name 
   */
  upLoadFilesAction (name, files) {


    const form = new FormData()
    form.append('imgId', this.state.imgId)

    if (name === 'pdfFiles') {
      form.append('textdata', files[0])
    } else {
      form.append('filedata', files[0])
    }

    addResearchReportPicture(form)
      .then(res => {
        if (res.info === 'success') {
          alert('上传成功')
        } else {
          alert('请重试')
        }
      })
  }

  /**
   * 弹出窗口
   */
  renderDialog () {
    return (
      <div className={s.dialogWrapper}>
        <div className={classNames(s.dialog, s.wrapper)}>
          <div className={s.dialogClose} onClick={this.close}>X</div>
          <h2 className={s.dialogTitle}>添加报告</h2>

          <hr/>

          <div className={s.item}>
            <label className={s.label}>标题：</label>
            <input type="text" className={s.input} value={this.state.headline} placeholder="请输入标题" onChange={this.changeValueTitle} />
            
            <label className={s.label}>发布日期：</label>
            <TimeInput className={s.input} value={this.state.date} onChange={value => this.changeHandle('date', value)} />

            <label className={s.label}>是否置顶：</label>
            <select className={s.input} value={this.state.stick + ''} onChange={e => {this.changeHandle('stick', e.target.value)}}>
              <option value="true">置顶</option>
              <option value="false">不置顶</option>
            </select>
          </div>
          
          <hr/>

          <div className={s.item}>
            <label className={s.label}>文章类型：</label>
            <select className={s.input} value={this.state.articleType} onChange={e => this.changeHandle('articleType', e.target.value)}>
              <option value="wx">微信文章</option>
              <option value="pdf">PDF图片</option>
            </select>

            <label className={s.label}>URL：</label>
            <input type="text" placeholder="请输入文章url" className={s.input} value={this.state.articleUrl} onChange={e => this.changeHandle('articleUrl', e.target.value)} />
            <button type="button" className={s.btn} onClick={() => this.changeReport(this.state.articleUrl)}>查询</button>
          </div>

          <hr/>

          <div className={s.item}>
            <label className={s.label}>摘要：</label>
            <textarea className={s.textarea} rows={4} placeholder="请输入摘要" onChange={this.changeDigest} value={this.state.digest}></textarea>
          </div>

          <hr/>

          <div className={s.item} style={{
            paddingLeft: '100px'
          }}>
            <button type="button" className={classNames(s.btn, s.danger)} onClick={this.saveReport}>保存</button>
          </div>

          <hr/>

          <div className={s.item}>
            <label className={s.label}>封面图片：</label>
            <input type="file" onChange={e => this.changeFiles(e, 'picFiles')} className={s.input} accept=".gif,.jpg,.jpeg,.png" />
            <button type="button" className={s.btn} onClick={() => this.upLoadFiles('picFiles')}>上传图片</button>
            <img style={{height: '100px'}} src={this.state.picture_url} alt={this.state.headline} />
          </div>

          <hr/>

          {this.state.articleType === 'pdf' ?
            <div className={s.item}>
              <label className={s.label}>PDF文件：</label>
              <input type="file" onChange={e => this.changeFiles(e, 'pdfFiles')} className={s.input} accept=".pdf" />
              <button type="button" className={s.btn} onClick={() => this.upLoadFiles('pdfFiles')}>上传文件</button>
            </div>
            : null
          }
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className={s.container}>
        <AdminBackNav />
        {this.state.show ? this.renderDialog() : null}
        <div className={s.titleWrapper}>
          <h1>研究报告管理</h1>
          <div className={s.btnGroup}>
            <button type="button" className={s.btn} onClick={() => this.open(true)}>新增</button>
          </div>
        </div>

        <div className={s.wrapper} style={{minHeight: 200}}>
          {this.renderList()}
        </div>

      </div>
    )
  }
}

export default withStyles(s)(ReportFrom)



// WEBPACK FOOTER //
// src/routes/cms/Report.js